import React from 'react';

import { CHEVRON_RIGHT_ICON } from '../../../../constants/images';
import { ICard } from '../../../../interfaces/cards';
import BdsIconButton from '../../Buttons/BdsIconButton/BdsIconButton';
import './Card.scss';

const Card = ({
  title,
  className,
  children,
  flexDirection = 'column',
  redirect,
  headButton
}: React.PropsWithChildren<ICard>) => {
  return (
    <div
      className={`card-container-v3 ${flexDirection === 'row' ? 'flex-row' : 'flex-col'} ${className}`}
      data-experience="new"
    >
      <div className="card-header">
        {title && <div className="title-container">{title}</div>}
        {redirect && <BdsIconButton icon={CHEVRON_RIGHT_ICON} action={redirect} variant="primary" size="sm" />}
        {headButton && <div className="head-button">{headButton}</div>}
      </div>
      {children}
    </div>
  );
};

export default Card;
